<script>
  // Import isHistoryLoading store
  import { history, user, isHistoryLoading } from '../stores/stores.js'; // Import user store and isHistoryLoading
  // Remove import for storeService if removeHistoryItem was used from there
  // import { removeHistoryItem } from '../services/storeService'; // Remove this line
  import { deleteSearchThread, loadUserSearchHistory } from '../services/searchService.js'; // Add loadUserSearchHistory
  import { openModal } from "svelte-modals";
  import ConfirmCancelModal from "./modals/ConfirmCancelModal.svelte";
  import { t } from '../services/translation/translationService.js';

  export let handleHistoryClick;

  let itemToDelete = null;

  function confirmDelete(threadId) {
    itemToDelete = threadId;
    openModal(ConfirmCancelModal, {
      message: $t('historyDeleteThreadText'),
      onConfirm: handleConfirmDelete,
      onCancel: handleCancelDelete
    });
  }

  async function handleConfirmDelete() {
    if (itemToDelete) {
      // 1. Get current user ID
      const currentUserId = $user?.userId; // Adjust based on actual user store structure
      if (!currentUserId) {
        console.error("Cannot delete: User ID not found in store.");
        itemToDelete = null; // Reset itemToDelete
        // Optionally: Show error to user
        return;
      }

      try {
        console.log(`Attempting to delete thread ${itemToDelete} via backend...`);
        // 2. Call backend delete and WAIT for completion
        await deleteSearchThread(itemToDelete);
        console.log(`Thread ${itemToDelete} deleted successfully. Reloading history...`);

        // 3. Reload history from DB AFTER successful delete
        const updatedHistory = await loadUserSearchHistory(currentUserId);
        // 4. Update the store with confirmed data from DB
        history.set(updatedHistory);
        console.log('History store updated from DB after delete.');

        itemToDelete = null; // Reset itemToDelete after successful operation

      } catch (error) {
        console.error(`Failed to delete thread ${itemToDelete} or reload history:`, error);
        itemToDelete = null; // Reset itemToDelete on error
        // Optionally: Show error message to user (e.g., "Failed to delete thread")
      }
    }
  }

  function handleCancelDelete() {
    itemToDelete = null;
  }

  function getDisplayText(item) {
    // console.log('Getting display text for item:', item); // Add this line
    return item.Title || (item.Queries && item.Queries.length > 0 ? item.Queries[0].query : 'Undefined Query');
  }

  // Function to generate a unique key for each history item
  function getUniqueKey(item, index) {
    return item.ThreadId ? `${item.ThreadId}-${index}` : `index-${index}`;
  }
</script>

<div class="history">
  {#if $isHistoryLoading}
    <div class="loading-container">
      <div class="loading-spinner"></div>
    </div>
  {:else}
    <ul>
      {#if $history && $history.length > 0}
        {#each $history as item (item.ThreadId)}
          <li>
            <button on:click={() => handleHistoryClick(item)}>
              {item.Title || (item.Queries && item.Queries.length > 0 ? item.Queries[0].query : 'Undefined Query')}
            </button>
            <button class="remove-btn" on:click={() => confirmDelete(item.ThreadId)}>✖</button>
          </li>
        {/each}
      {:else}
        <li class="no-history">{$t('historyNoHistory')}</li>
      {/if}
    </ul>
  {/if}
</div>

<style>
  .history {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    overflow: hidden;
    position: relative;
  }

  .loading-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
  }

  .loading-spinner {
    width: 30px;
    height: 30px;
    border: 3px solid rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    border-top-color: #ffffff;
    animation: spin 0.8s linear infinite;
  }

  @keyframes spin {
    to { transform: rotate(360deg); }
  }

  .history ul {
    list-style: none;
    padding: 0;
    margin: 0;
    flex: 1;
    overflow-y: auto;
    width: 100%; 
    display: flex;
    flex-direction: column;
    min-height: 0;
    max-height: 100%;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
  }

  .history ul::-webkit-scrollbar { /* WebKit */
    display: none;
  }

  .history li {
    position: relative;
    padding: 2px 5px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #333;
  }

  .history button {
    text-align: left;
    background: none;
    border: none;
    color: #ffffff;
    cursor: pointer;
    padding: 2px 5px;
    flex-grow: 1;
    max-width: calc(100% - 40px);
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
  }

  .history button:hover {
    background-color: #002357;
  }

  .history .remove-btn {
    position: absolute;
    right: 10px;
    background: none;
    border: none;
    color: #ffffff;
    cursor: pointer;
    padding: 2px 5px;
  }

  .history .remove-btn:hover {
    color: #cccccc;
  }

  .no-history {
    justify-content: center;
  }
</style>